// -----------------------------
// swiper系
// -----------------------------

(function () {
  //swiper
  let villalistSlide = new Swiper(".js-villalist-slide", {
    navigation: {
      nextEl: ".villalist-btn-next",
      prevEl: ".villalist-btn-prev",
    },
    // pagination: {                       //ページネーション（ドット）
    //     el: '.villalist-pagination',
    // },
    autoplay: true,
    loop: true,
    speed: 600,
    slidesPerView: 1,
    breakpoints: {
      769: {
        slidesPerView: 3,
      },
    },
  });
})();
